import { StrictFilters } from "../hooks/useTasksOverview";
import { getRelevantUsersIds } from "./getRelevantUsersIds";

export const addTeamFiltersToQueryOptions = async (
  uid: string,
  queryOptions: StrictFilters,
  createdBy: string,
  assignedTo: string
) => {
  if (createdBy !== "") {
    queryOptions.createdBy = await getRelevantUsersIds(uid, createdBy);
  }
  if (assignedTo !== "") {
    queryOptions.assignedTo = assignedTo;
  }
};
